import React from 'react';
import { withTranslation } from "react-i18next";
import './TotalSuppliers.scss';


function TotalSuppliers({ t, totalSupplier, isDashboardView }) {
  return (
    <>{
      isDashboardView
        ?
        <div className="Sc-Total_supplierBox02">
          <table className='table m-0'>
            <thead>
              <tr>
                <th scope="col">{t("TotalSuppliers.label")}</th>
                <th scope="col" className='text-end'>{t("Value.label")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><h6 className='m-0'>{t("TotalSuppliers.label")}</h6></td>
                <td className='text-end'><h5 className='m-0'>{totalSupplier}</h5></td>
              </tr>
            </tbody>
          </table>
        </div>
        :
        <div className="col-lg-2 p-2">
          <div className="card">
            <div className="card-body">
              <h6>{t("TotalSuppliers.label")}</h6>
              <h4 className="m-0">{totalSupplier}</h4>
            </div>
          </div>
        </div>
    }</>

  )
}

export default withTranslation()(TotalSuppliers)
